import { render, staticRenderFns } from "./EnergyPlans.vue?vue&type=template&id=b6247e72&"
import script from "./EnergyPlans.vue?vue&type=script&lang=js&"
export * from "./EnergyPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports